export const LOGIN_SHOWCASE_FEATURES = [
  {
    key: 'insights',
    title: 'Real-time Insights',
    description: 'Stay updated with live data.',
  },
  {
    key: 'decisions',
    title: 'Smarter Decisions',
    description: 'Make confident, data-driven choices.',
  },
  {
    key: 'impact',
    title: 'Measurable Impact',
    description: 'Track progress and drive results.',
  },
];
